export interface LegalReacceptanceSegment {
  type: 'text' | 'link';
  text: string;
  url?: string;
  documentKey?: string;
  version?: string;
}

export interface LegalReacceptanceCheckbox {
  id?: string;
  required: boolean;
  segments: LegalReacceptanceSegment[];
}

export type LegalReacceptanceAgreementVersions = Record<string, string>;

export enum LegalReacceptanceAgreementURLKey {
  ACH_AUTHORIZATION = 'ach-authorization',
  E_SIGN = 'e-sign',
  PRIVACY_POLICY = 'privacy-policy',
  TERMS_OF_SERVICE = 'terms-of-service'
}

export interface LegalReacceptanceAgreementURL {
  label: string;
  url: string;
  version: string;
}

export type LegalReacceptanceAgreementURLs = Partial<
  Record<LegalReacceptanceAgreementURLKey, LegalReacceptanceAgreementURL>
>;

export type LegalAgreementEventType = 'BANKING' | 'RE-ACCEPTANCE';

export enum CleverTapEventsLegalReacceptance {
  webLegalReacceptanceModalView = 'Web_Legal_Reacceptance_Modal_View',
  webLegalReacceptanceAcceptClick = 'Web_Legal_Reacceptance_Accept_Click'
}

export interface LegalAgreementAcceptancePayload {
  eventType: LegalAgreementEventType;
  legalAgreementsAcceptanceData: {
    ip: string;
    deviceInfo: Record<string, string>;
    agreementVersions: LegalReacceptanceAgreementVersions;
    acceptedAt: string;
  };
}

export interface LegalReacceptanceContent {
  type: string;
  title: string;
  body: string;
  confirmButtonText: string;
  checkboxes: LegalReacceptanceCheckbox[];
  agreementVersions?: LegalReacceptanceAgreementVersions;
  agreementURLs?: LegalReacceptanceAgreementURLs;
}
